import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { primaryTags } from './utils';

/**
 * Homepage topic grid: up to five primary tags rendered as colored tiles.
 * Reads tags straight from the store (preloaded by flarum/tags); renders
 * nothing if the tags extension is absent or there are no primary tags.
 */
export default class HomeTopics extends Component {
  view() {
    const tags = primaryTags();
    if (!tags.length) return null;
    return m("section", {
      className: "HomeSection HomeSection--topics"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "HomeSection-head"
    }, m("h2", null, m("i", {
      className: "fas fa-hashtag"
    }), " ", app.translator.trans('glowingblue-demo.forum.home.topics.heading')), m(Link, {
      href: app.route('tags'),
      className: "HomeSection-more"
    }, app.translator.trans('glowingblue-demo.forum.home.topics.all'), " ", m("i", {
      className: "fas fa-arrow-right"
    }))), m("div", {
      className: "HomeTopics"
    }, tags.slice(0, 5).map(tag => {
      var _tag$discussionCount, _tag$discussionCount2;
      const color = tag.color() || 'var(--be-glow-strong)';
      return m(Link, {
        href: app.route('tag', {
          tags: tag.slug()
        }),
        className: "HomeTopic",
        style: {
          '--c': color
        }
      }, m("span", {
        className: "HomeTopic-ico",
        style: {
          color
        }
      }, m("i", {
        className: tag.icon() || 'fas fa-hashtag'
      })), m("span", {
        className: "HomeTopic-nm"
      }, tag.name()), m("span", {
        className: "HomeTopic-ct"
      }, app.translator.trans('glowingblue-demo.forum.home.topics.discussion_count', {
        count: (_tag$discussionCount = (_tag$discussionCount2 = tag.discussionCount) == null ? void 0 : _tag$discussionCount2.call(tag)) != null ? _tag$discussionCount : 0
      })));
    }))));
  }
}
flarum.reg.add('glowingblue-demo', 'forum/components/home/HomeTopics', HomeTopics);